import chooseRecognitionTpl from './chooseRecognition.tpl.html';

export default {
    templateUrl: chooseRecognitionTpl
};
